export const appStoreUrl = `https://apps.apple.com/app/id1472183741`